module.exports = __webpack_public_path__ + "img/qua.6e28a4d3.png";